import type { VisualEditorComponentProps } from 'drupal-visual-editor';
import { openVisualEditorComponent } from 'drupal-visual-editor';
import { useContext } from 'react';
import { PathContext } from '~/jobiqo/context/app';

interface VisualEditorComponentContainerProps
  extends VisualEditorComponentProps {
  children?: React.ReactNode;
}

export default function VisualEditorComponentContainer({
  action = 'edit',
  storage = 'paragraph',
  uuid,
  children,
}: VisualEditorComponentContainerProps) {
  const { querystring } = useContext(PathContext);

  return (querystring as any)?.visual_editor === 'true' ? (
    <section
      id={`${storage}-${uuid}`}
      data-visual-editor-component={`${storage}-${uuid}`}
      onClick={() => {
        openVisualEditorComponent({
          action,
          storage,
          uuid,
        });
      }}
    >
      {children}
    </section>
  ) : (
    <section>{children}</section>
  );
}
